import { render, staticRenderFns } from "./FindOriginalButton.vue?vue&type=template&id=fb17a436&"
import script from "./FindOriginalButton.vue?vue&type=script&lang=js&"
export * from "./FindOriginalButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports